import {PropsWithChildren} from "react";
import {generatePath, Navigate, useParams} from "react-router-dom";
import {useNewDesignEnabled} from "~/new-design/hooks";
import {urls} from "~/routes/consumerUrls";

export const NewDesignOnlyGate = ({children}: PropsWithChildren) => {
  const isNewDesign = useNewDesignEnabled();
  const {accountId = ""} = useParams<{accountId: string}>();
  if (!isNewDesign) return <Navigate to={generatePath(urls.accountMain.url, {accountId})} replace />;
  return <>{children}</>;
};
